export const chargeTypes = [
  { label: "Presidente", value: "PRESIDENT" },
  { label: "Secretario", value: "SECRETARY" },
  { label: "Vocal", value: "BOARD_MEMBER"},
  { label: "Comisario", value: "AUDITOR"},
  { label: "Tesorero", value: "TREASURER" }
]
